import {AuthModel} from '../../../../components/api'

const AUTH_LOCAL_STORAGE_KEY = 'polab-auth-v1'
const LEGACY_AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

const getAuth = (): AuthModel | undefined => {
  try {
    const currentValue = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
    const legacyValue = localStorage.getItem(LEGACY_AUTH_LOCAL_STORAGE_KEY)
    const value = currentValue ?? legacyValue

    if (!value) {
      return
    }

    const auth = JSON.parse(value) as AuthModel
    if (auth && !currentValue) {
      localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, value)
      localStorage.removeItem(LEGACY_AUTH_LOCAL_STORAGE_KEY)
    }

    return auth
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  try {
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, JSON.stringify(auth))
    localStorage.removeItem(LEGACY_AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
    localStorage.removeItem(LEGACY_AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: {headers: {Authorization: string}}) => {
      const auth = getAuth()
      if (auth?.apiToken) {
        config.headers.Authorization = `Bearer ${auth.apiToken}`
      }

      return config
    },
    (error: unknown) => Promise.reject(error)
  )
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY}
